import React, { useMemo, useRef } from "react";
import { Colors } from "../../utils/colors";

type ListTabsProp = {
  tabLabels: string[];
  tabIcons?: React.ReactNode[];
  tabNumbers: number[];
  selectedValue: number;
  onChange: (index: number) => void;
  containerStyles?: React.CSSProperties;
  tabStyles?: React.CSSProperties;
  selectedTabStyles?: React.CSSProperties;
  altColor?: string;
  loading?: boolean;
  newSelectedTextColor?: string;
  newTextColor?: string;
};

const ListTabs = (props: ListTabsProp) => {
  const {
    tabLabels,
    tabIcons,
    tabNumbers,
    selectedValue,
    onChange,
    containerStyles,
    tabStyles,
    selectedTabStyles,
    altColor,
    loading,
    newSelectedTextColor,
    newTextColor,
  } = props;

  const styles = {
    tabContainer: {
      transition: "all 200ms ease",
      borderRadius: 20,
      paddingBlock: 8,
      paddingInline: 10,
      gap: 5,
    },
    tabText: {
      fontSize: 13,
      fontWeight: "500",
    },
  };

  const slider = useRef<HTMLDivElement>(null);

  const textColorToShow = useMemo(
    () => newTextColor ?? Colors.GRAY1,
    [newTextColor]
  );
  const selectedTextColorToShow = useMemo(
    () => newSelectedTextColor ?? Colors.WHITE,
    [newSelectedTextColor]
  );

  return (
    <div className="AlignedRow" style={{ gap: 4, ...containerStyles }}>
      {tabLabels.map((label, index) => (
        <div
          key={index}
          ref={slider}
          onClick={() => onChange(index)}
          className="AlignedRowSelect"
          style={{
            ...styles.tabContainer,
            border: `0.5px solid ${
              selectedValue === index ? altColor || Colors.BLUE5 : Colors.GRAY2
            }`,
            backgroundColor:
              selectedValue === index
                ? altColor || Colors.BLUE5
                : tabStyles?.backgroundColor || Colors.WHITE1,
            ...(selectedValue === index ? selectedTabStyles : tabStyles),
          }}
        >
          {tabIcons?.[index] ? tabIcons[index] : null}
          <span
            style={{
              ...styles.tabText,
              color:
                selectedValue === index
                  ? selectedTextColorToShow
                  : textColorToShow,
            }}
          >
            {label}
          </span>
          {tabNumbers[index] !== -1 ? (
            <span
              style={{
                ...styles.tabText,
                color:
                  selectedValue === index
                    ? selectedTextColorToShow
                    : textColorToShow,
              }}
            >
              {loading ? "(...)" : `(${tabNumbers[index]})`}
            </span>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default ListTabs;
